import { useState, useEffect } from "react";

//Importing hooks from react-router-dom
import { useNavigate } from "react-router-dom";

// Supondo que o TestDetails (ou Test) possua a propriedade “questions” do tipo QuestionDetails[]
import { TestDetails } from "../../../../hooks/test/types/types";

import { CreateDiagramInput, DiagramFull } from "../../../../hooks/diagrams/types/types";

import { useDiagrams } from "../../../../hooks/diagrams/useDiagrams";

import { QuestionPage } from "../components/DiagramacaoPreview/types/types";


export default function useDiagramacaoForm({ token, editMode, printMode, id }: { token: string; editMode?: boolean; printMode?: boolean; id?: string }) {
  // Estados de carregamento e mensagem de erro
  const [loading, setLoading] = useState(false);
  const [loadingPage] = useState(false);
  const [msgErro, setMsgErro] = useState("");

  // Estados referentes ao teste/prova
  // Supondo que o objeto selecionado possua a propriedade "questions" com os detalhes das questões.
  const [provaSelect, setProvaSelect] = useState<TestDetails | null>(null);
  const [processo] = useState<any>(null);

  // Estados de configuração (ex.: layout, margens, fontes, logos etc.)
  const [logoPath, setLogoPath] = useState("");
  const [logoPathInferior, setLogoPathInferior] = useState("");
  const [tituloPagina, setTituloPagina] = useState("");
  const [nomeProva, setNomeProva] = useState("");
  const [instrucoes, setInstrucoes] = useState("");
  const [numeroColunas, setNumeroColunas] = useState(2);
  const [fontSizeQuestoes, setFontSizeQuestoes] = useState<number | "default">(
    13
  );
  const [fontSizeInstrucoes, setFontSizeInstrucoes] = useState(13);
  const [marginSuperior, setMarginSuperior] = useState(14);
  const [marginInferior, setMarginInferior] = useState(40);
  const [marginEsquerda, setMarginEsquerda] = useState(40);
  const [marginDireita, setMarginDireita] = useState(40);
  const [pages, setPages] = useState<any[]>([]);
  const [loadingPdf] = useState(false);

  // Campos básicos da prova
  const [nickNameLayout, setNickNameLayout] = useState<string>("");
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [titleHeader, setTitleHeader] = useState("");
  const [subtitleHeader, setSubtitleHeader] = useState("");
  const [questionPages, setQuestionPages] = useState<QuestionPage[]>([]);

  // Logos
  const [logo, setLogo] = useState<File | null | string>(null);
  const [logoBottom, setLogoBottom] = useState<File | null | string>(null);

  // Configurações de fonte e layout
  const [fontSizeRules, setFontSizeRules] = useState(13);
  const [fontSizeAlternatives, setFontSizeAlternatives] = useState<
    "default" | number
  >("default");
  const [numberColumnsRules, setNumberColumnsRules] = useState(1);
  const [showDiscipline, setShowDiscipline] = useState(true);
  const [borderVisible, setBorderVisible] = useState(true);

  // Configurações de randomização
  const [randomQuestion, setRandomQuestion] = useState(false);
  const [randomAlternatives, setRandomAlternatives] = useState(false);
  const [randomPerCategory, setRandomPerCategory] = useState(false);
  const [selectFromGroup, setSelectFromGroup] = useState(false);
  const [numberSelectQuestions, setNumberSelectQuestions] = useState(0);

  // Configurações da folha de resposta
  const [titleAnswer, setTitleAnswer] = useState("");
  const [subtitleAnswer, setSubtitleAnswer] = useState("");
  const [nameAnswer, setNameAnswer] = useState("");
  const [answerPageVisible, setAnswerPageVisible] = useState(true);
  const [rules, setRules] = useState("");
  const [rulesAnswer, setRulesAnswer] = useState("");

  // Configurações de layout padrão
  const [defaultLayout, setDefaultLayout] = useState(false);
  const [nameDefault, setNameDefault] = useState("");

  // Dados para a página de rosto (front page)
  const [dataFrontPage, setDataFrontPage] = useState([
    {
      element: '<div><img src="%LOGO%" width="70" height="56"></div>',
      x: 8,
      y: 16,
      width: 237,
      height: 67,
    },
    {
      element: '<hr style="border: 0.5px solid #ccc;"><div><br></div>',
      x: 4,
      y: 91,
      width: 769,
      height: 32,
    },
    {
      element:
        '<div style="text-align: center;"><strong><span style="font-size: 30px;">:nome_seletivo</span></strong></div><div style="text-align: center;"><strong style="font-size: 24px;">:nome_cargo</strong></div><div style="text-align: center;"><strong style="font-size: 24px;">:nome_prova</strong></div><div style="text-align: center;"><strong style="font-size: 24px;"><br></strong></div>',
      x: 10,
      y: 128,
      width: 758,
      height: 139,
    },
    {
      element:
        '<table style="width: 100%; border: 0.5px solid #ccc;"><tbody><tr><td style="width: 100%; background-color: rgb(0, 0, 0);"><span style="color: rgb(255, 255, 255);"><strong style="font-size: 24px;">INSTRUÇÕES GERAIS</strong></span></td></tr><tr><td style="width: 100%; text-align: justify;">1) INSTRUÇÃO 1<br>2) INSTRUÇÃO 2<br>3) INSTRUÇÃO 3<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br></td></tr></tbody></table>',
      x: 9.5,
      y: 300,
      width: 758,
      height: 708,
    },
    {
      element:
        '<table style="width: 100%; border: 0.5px solid #ccc;"><tbody><tr><td style="width: 50%; border-right: 0.5px solid #ccc; text-align: justify; padding: 8px;"><strong>Cargo: </strong>:nome_cargo</td><td style="width: 50%; text-align: justify; padding: 8px;"><strong>Turno: </strong>Manhã</td></tr></tbody></table>',
      x: 10.5,
      y: 248,
      width: 754,
      height: 70,
    },
    {
      element:
        '<div style="text-align: center;"><img src="%LOGO_BOTTOM%" width="70" height="39" style="display: block; margin-left: auto; margin-right: auto;"></div>',
      x: 289,
      y: 1049,
      width: 199,
      height: 54,
    },
    {
      element: '<div style="text-align: center;">Realização</div>',
      x: 332.5,
      y: 1012,
      width: 112,
      height: 33,
    },
  ]);

  // Hook para navegação
  const navigate = useNavigate();

  const { createDiagram, getDiagramById, updateDiagram } = useDiagrams(token);
  const [nameTestSelect, setnameTestSelect] = useState("");

  const populateDiagramData = (diagramData: DiagramFull) => {



    setnameTestSelect(diagramData.test.name || "");

    setTitle(diagramData.pageTitle || "");
    setSubtitle(diagramData.pageSubtitle || "");
    setNomeProva(diagramData.testName || "");
    setNickNameLayout(diagramData.nicknameLayout || "");
    setNumeroColunas(diagramData.numberOfColumns || 1);
    setFontSizeRules(diagramData.fontSizeRules || 13);
    setFontSizeQuestoes(diagramData.fontSizeQuestions || 13);
    setFontSizeAlternatives(
      typeof diagramData.fontSizeChoices === "number"
        ? diagramData.fontSizeChoices
        : "default"
    );
    setMarginSuperior(diagramData.marginTop || 10);
    setMarginDireita(diagramData.marginRight || 10);
    setMarginEsquerda(diagramData.marginLeft || 10);
    setMarginInferior(diagramData.marginBottom || 10);
    setRandomQuestion(diagramData.randomizeQuestions || false);
    setRandomAlternatives(diagramData.randomizeChoices || false);
    setShowDiscipline(diagramData.showDiscipline || false);
    setBorderVisible(diagramData.borderVisible || false);
    setLogo(diagramData.logo ?? null);
    setLogoBottom(diagramData.bottomLogo ?? null);
    setDefaultLayout(diagramData.defaultDiagram || false);
    setNameDefault(diagramData.defaultName || "");

    if (diagramData.pages) {
      try {
      if (typeof diagramData.pages === "string") {
        const parsedPages = JSON.parse(diagramData.pages);
        setQuestionPages(parsedPages);
      } else if (Array.isArray(diagramData.pages)) {
        setQuestionPages(diagramData.pages);
      } else {
        console.error("Expected pages to be a string or array, but got:", typeof diagramData.pages);
      }
      } catch (error) {
      console.error("Erro ao parsear pages:", error);
      }
    }

  };

  // Fetch disciplines data in edit mode
  // Uso da função dentro do useEffect para fetch dos dados em editMode
  useEffect(() => {
    const fetchDiagramByData = async () => {
      if ((editMode && id) || printMode) {
        setLoading(true);
        try {
          const diagramData = await getDiagramById(id as string);


          if (diagramData) {
            populateDiagramData(diagramData);
            setProvaSelect(diagramData.test as unknown as TestDetails);
          }
        } catch (error) {
          console.error("Erro ao buscar dados do diagrama:", error);
          setMsgErro("Erro ao buscar dados do diagrama.");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchDiagramByData();
  }, [editMode, id, printMode, getDiagramById]);

  /**
   * Função para construir as páginas da diagramação.
   *
   * Agora, para cada questão, verificamos:
   * - Se a propriedade “subQuestions” contém mais de uma questão **e**
   *   o enunciado principal (questao.statement) está preenchido, trata-se de uma “questão do tipo set”
   *   e, portanto, adicionamos um bloco para o enunciado principal e, em seguida, iteramos sobre as subquestões.
   * - Caso contrário, tratamos a questão como “simples”: exibindo o enunciado (ou o enunciado da única subquestão)
   *   e, se for objetiva (possuir “objectives” na primeira subquestão), renderizamos as alternativas.
   */

  // Sempre que a prova selecionada ou as variáveis que afetam a diagramação mudarem, reconstrói as páginas
  useEffect(() => {
    if (provaSelect) {
    }
  }, [
    provaSelect,
    numeroColunas,
    fontSizeQuestoes,
    marginSuperior,
    marginInferior,
    marginEsquerda,
    marginDireita,
  ]);

  /**
   * Função para salvar a diagramação.
   *
   * Essa função utiliza os estados do hook para montar um objeto de
   * configuração do diagrama (do tipo CreateDiagramInput) e, em seguida,
   * chama o método de criação do diagrama exposto pelo hook useDiagrams.
   *
   * @param imprimir - Se true, pode incluir lógica adicional para geração de PDF ou impressão.
   */
  const handleSave = async (imprimir: boolean) => {
    setLoading(true);
    setMsgErro("");

    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const diagramData: CreateDiagramInput  = {
        page_title: title,
        page_subtitle: subtitle,
        test_name: nomeProva,
        nickname_layout: nickNameLayout,
        number_of_columns: numeroColunas,
        font_size_rules: fontSizeRules,
        font_size_questions:
          typeof fontSizeQuestoes === "number" ? fontSizeQuestoes : 13,
        font_size_choices:
          typeof fontSizeAlternatives === "number" ? fontSizeAlternatives : 13,
        margin_top: marginSuperior,
        margin_right: marginDireita,
        margin_left: marginEsquerda,
        margin_bottom: marginInferior,
        randomize_questions: randomQuestion,
        randomize_choices: randomAlternatives,
        show_discipline: showDiscipline,
        border_visible: borderVisible,
        default_diagram: defaultLayout,
        test_id: provaSelect?.id || "",

        // Aqui chamamos JSON.stringify para enviar como string
        pages: JSON.stringify(questionPages),
      };


      if(editMode && id) {
        try {
          await updateDiagram({ id, ...diagramData });
          navigate("/layouts_default_exams");
        } catch (error) {
          console.error("Erro ao atualizar diagramação:", error);
          setMsgErro("Erro ao atualizar diagramação.");
        }
      } else {

        try {
          const diagram = await createDiagram(diagramData);
          if (diagram) {
            setMsgErro("Diagramação salva com sucesso.");
            navigate("/layouts_default_exams");
          }
        } catch (error) {
          console.error("Erro ao criar diagramação:", error);
          setMsgErro("Erro ao criar diagramação.");
        }
        
      }

    } catch (error: any) {
      console.error(error);
      setMsgErro("Erro ao salvar diagramação.");
    } finally {
      setLoading(false);
    }
  };

  return {
    // Retorno dos estados e funções para utilização no componente
    loading,
    setLoading,
    nameTestSelect,
    loadingPage,
    loadingPdf,
    msgErro,
    setMsgErro,
    processo,
    questionPages,
    setQuestionPages,
    provaSelect,
    setProvaSelect,
    logoPath,
    setLogoPath,
    logoPathInferior,
    setLogoPathInferior,
    tituloPagina,
    setTituloPagina,
    nomeProva,
    setNomeProva,
    instrucoes,
    setInstrucoes,
    numeroColunas,
    setNumeroColunas,
    fontSizeQuestoes,
    setFontSizeQuestoes,
    fontSizeInstrucoes,
    setFontSizeInstrucoes,
    marginSuperior,
    setMarginSuperior,
    marginInferior,
    setMarginInferior,
    marginEsquerda,
    setMarginEsquerda,
    marginDireita,
    setMarginDireita,
    pages,
    setPages,
    handleSave,
    nickNameLayout,
    setNickNameLayout,
    title,
    setTitle,
    subtitle,
    setSubtitle,
    titleHeader,
    setTitleHeader,
    subtitleHeader,
    setSubtitleHeader,
    logo,
    setLogo,
    logoBottom,
    setLogoBottom,
    fontSizeRules,
    setFontSizeRules,
    fontSizeAlternatives,
    setFontSizeAlternatives,
    numberColumnsRules,
    setNumberColumnsRules,
    showDiscipline,
    setShowDiscipline,
    borderVisible,
    setBorderVisible,
    randomQuestion,
    setRandomQuestion,
    randomAlternatives,
    setRandomAlternatives,
    randomPerCategory,
    setRandomPerCategory,
    selectFromGroup,
    setSelectFromGroup,
    numberSelectQuestions,
    setNumberSelectQuestions,
    titleAnswer,
    setTitleAnswer,
    subtitleAnswer,
    setSubtitleAnswer,
    nameAnswer,
    setNameAnswer,
    answerPageVisible,
    setAnswerPageVisible,
    rules,
    setRules,
    rulesAnswer,
    setRulesAnswer,
    defaultLayout,
    setDefaultLayout,
    nameDefault,
    setNameDefault,
    dataFrontPage,
    setDataFrontPage,
  };
}
